import './hero.less'

import {m} from '@codeurs/front'
import styled from '@emotion/styled'
import {FunctionComponent} from 'react'
import {style} from 'util/style'
import {H1, Theme} from 'views/theme'

const styles = style('hero')

type HeroType = {
	hero: boolean
	small?: boolean
	wide?: boolean
	half?: boolean
	className?: string
}

const H1Dark = styled(H1)`
	color: #3f485b;
`

export const Hero: FunctionComponent<HeroType> = ({
	small,
	hero,
	wide,
	half,
	className,
	children
}) => {
	return (
		<div class={styles.with(className)}>
			<Theme extend={hero ? {} : {H1: H1Dark}}>
				<Theme.Container>
					<div class={styles('container').mod({small, wide, half})}>
						{children}
					</div>
				</Theme.Container>
			</Theme>
		</div>
	)
}
